import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
    };
}
const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
    productsDataView: getProductListDataView(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    mobileFilterGridItem?: GridItemProps;
    hiddenMobileFilterStyles?: HiddenProps;
    searchkeyWordFilters?: GridItemProps;
    hiddenSearchKeywordStyles?: HiddenProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            padding-top: 16px;
            > div {
                background:  ${getColor("primary.contrast")};
                height: 85px;
                border: 4px solid ${COLORS.background.grayShade};
                padding-top: 16px;
                gap: 24px;
                @media (min-width: 768px) and (max-width: 991px) {
                    flex-wrap: wrap;
                    height: 130px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                            flex-direction: column;
                        `,
                    css`
                            flex-direction: column;
                        `,
                    css`
                            flex-direction: row;
                            gap: 16px;
                            padding-top: 10px;
                            padding-bottom: 20px;
                            justify-content: space-around;
                        `,
                    css`
                            padding-left: 24px;
                            @media (min-width: 992px) and (max-width: 1280px) {
                                padding-left: 10px !important;
                            }
                        `,
                    css`
                            padding-left: 24px;
                        `,
                ])}
            }
        `,
    },
    countGridItem: {
        width: [12, 12, 5, 2, 2],
        css: css`
            order: 1;
            @media (min-width: 768px) and (max-width: 991px) {
                flex-basis: 44% !important;
                max-width: 44% !important;
            }
            @media (min-width: 992px) and (max-width: 1280px) {
                flex-basis: 13.666667% !important;
                max-width: 13.666667% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css`
                        // flex-basis: 40% !important;
                        // max-width: 40% !important;`,
                    css`
                        flex-basis: 16.666667%;
                        max-width: 16.666667%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    countTableViewGridItem: {
        width: [12, 12, 1, 1, 1],
        css: css``,
    },
    searchkeyWordFilters: {
        width: [0, 12, 3, 5, 5],
        css: css`
            order: 2;
            flex-basis: 35.666667% !important;
            max-width: 35.666667% !important;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 4;
                flex-basis: 80.666667% !important;
                max-width: 80.666667% !important;

            }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css``,
                        css``,
                        css`
                        padding-left: 5px;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1280px) {
                flex-basis: 28.666667% !important;
                max-width: 28.666667% !important;
            }
        `,
    },
    sortGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            order: 3;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 2;
            }
            @media (min-width: 992px) and (max-width: 1280px) {
                flex-basis: 31% !important;
                max-width: 31% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        flex-basis: 30.666667% !important;
                        max-width: 30.666667% !important;
                    `,
                    css`
                        margin-right: 10px;
                    `,
                    null,
                ])}
        `,
    },
    sortTableViewGridItem: {
        width: [12, 12, 5, 4, 3],
    },
    filterGridItem: {
        width: 0,
        css: css``,
    },
    filterTableViewGridItem: {
        width: [0, 0, 2, 2, 2],
    },
    viewSelectGridItem: {
        width: [0, 0, 2, 2, 1],
        css: css`   
            order: 4;
            flex-basis: 13.666% !important;
            max-width: 13.6666% !important;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 5;
                flex-basis: auto !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        @media (min-width: 992px) and (max-width: 1280px) {
                            flex-basis: 13.666% !important;
                            max-width: 13.6666% !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    viewSelectTableViewGridItem: {
        width: [0, 0, 5, 2, 1],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobileFilterGridItem: {
        width: [6, 6, 2, 0, 0],
    },
    hiddenMobileFilterStyles: {
        css: css`
            order: 5;
            align-self: flex-end;
            margin-right: 20px;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 3;
                margin-right: 0;
                align-self: flex-start;
            }
        `,
    },
    hiddenSearchKeywordStyles: {
        css: css``,
    },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ id, view, productsDataView, fields }) => {
    return productsDataView.value?.length === 0 ? null : (
        <GridContainer {...styles.container}
            style={{ background: `${fields.backgroundColor}` }}>
            <GridItem {...(view === "Table" ? styles.countTableViewGridItem : styles.countGridItem)}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>

            <GridItem {...styles.searchkeyWordFilters}>
                <Zone contentId={id} zoneName="Content05" />
            </GridItem>

            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>

            <GridItem {...(view === "Table" ? styles.filterTableViewGridItem : styles.filterGridItem)}>
                <Zone contentId={id} zoneName="Content02" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.viewSelectTableViewGridItem : styles.viewSelectGridItem)}>
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
            <Hidden above="md" {...styles.hiddenMobileFilterStyles}>
                <GridItem {...styles.mobileFilterGridItem}>
                    <Zone contentId={id} zoneName="ContentMobileFilter" />
                </GridItem>
            </Hidden>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "TextField",
                defaultValue: "linear-gradient(90deg,#266b40 27.08%,#2d804c 71.87%,#43687a 100%)",
                fieldType: "General",
                displayName: "Background Color",
            },
        ]
    },
};

export default widgetModule;
